//packages blocks
import moment from "moment";
import Lottie from "lottie-react";
import { Button } from "react-bootstrap";
import { useHistory } from "react-router";
import Grid from "@material-ui/core/Grid";
import { useTranslation } from "react-i18next";
import { Avatar, Paper } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Badge, Box, CircularProgress, styled, Typography } from "@material-ui/core";
//styles, utils, assets and api blocks
import { setAlert } from "../../../redux/reducers/alert";
import { globalSearches, topBarInfo } from "../../../api/users";
import { amountFormat } from "../../../util/constants";
import whiteLogo from "../../../../src/assets/images/dashboardPayNestLogo.svg";
import bellIcon from "../../../../src/assets/images/bell-icon.png";
import { BLUE_EIGHT } from "../../../theme";
import bellIconAnimation from "../../../../src/assets/video/bell-icon-animation.json";
import {PrimaryBackgroundColor} from "../../../styles/colors";

export const TopBar = ({
  onCl
}) => {
  const { token, id, profileImg, firstName, lastName } = useSelector((state) => state.user);
  const someUserData = useSelector((state) => state.user);
  const [notifyPop, setNotifyPop] = useState(false);
  const [loading, setLoading] = useState(false);
  const [IsVisibleGlobalSearchDialog, setIsVisibleGlobalSearchDialog] =
    useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [responseDataText, setResponseDataText] = useState("");
  const [students, setStudents] = useState([]);
  const [transactions, setTransactions] = useState([]);
  const [base64, setbase64] = useState([]);
  // const [newNotification, setNewNotification] = useState(false);
  const dispatch = useDispatch();
  const { t } = useTranslation();

  let notifyStorage = JSON.parse(localStorage.getItem("notify"));
  // let notifyStorage = [{newNotification:true,message:'text text',date:new Date()}]
  let newNotify;

  if (notifyStorage !== null) {
    newNotify = notifyStorage[notifyStorage.length - 1];
  } else {
    newNotify = {
      newNotification: false,
    };
  }

  const showErrorAlert = (message) => {
    dispatch(
      setAlert({
        severity: "error",
        message,
        show: true,
      })
    );
  };

  const [userData, setUserData] = useState({
    firstName: "",
    lastName: "",
    designation: "",
    file: ""
  });

  const notify = () => {
    if (notifyPop) {
      setNotifyPop(false);
    } else {
      setNotifyPop(true);
      if (notifyStorage !== null) {
        notifyStorage[notifyStorage.length - 1].newNotification = false;
        notifyStorage = localStorage.setItem(
          "notify",
          JSON.stringify(notifyStorage)
        );
      }
    }
  };

  if (notifyStorage !== null) {
    notifyStorage = notifyStorage.reverse();
  }

  const topBarUserInfo = async () => {
    const payload = {
      id: id,
    };
    try {
      const response = await topBarInfo(payload, token);
      if (response.status) {
        setUserData(response?.findUser);
      }
    } catch (error) {
    }
  };

  const globalSearch = async (e) => {
    setSearchValue(e.target.value);
    try {
      setIsVisibleGlobalSearchDialog(true);
      const payload = {
        data: e.target.value,
      };
      setLoading(true);
      const response = await globalSearches(payload, token);
      if (response.status === true) {
        if (response.data === "student") {
          setStudents(response?.students.rows);
          setResponseDataText(response?.data);
          if (response.students.rows.length === 0) {
            showErrorAlert("Record Not Found !");
          }
        } else {
          setTransactions(response?.transactions.rows);
          setResponseDataText(response?.data);
          if (response?.transactions.rows.length === 0) {
            showErrorAlert("Record Not Found !");
          }
        }
        setLoading(false);
      } else {
        setIsVisibleGlobalSearchDialog(false);
      }
    } catch (error) {
    }
  };

  useEffect(() => {
    if (profileImg != userData.file) {
      setbase64({
        ...userData,
        file: profileImg,
      })
      setUserData({ ...userData, file: profileImg })
    }
    if (firstName != userData.firstName) {
      setUserData({
        ...userData,
        firstName,
      })
    }
    if (lastName != userData.lastName) {
      setUserData({
        ...userData,
        lastName,
      })
    }
  }, [profileImg, firstName, lastName])

  useEffect(() => {
    topBarUserInfo();
  }, []);

  const Item = styled(Paper)(({ theme }) => ({
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: "start",
    color: theme.palette.text.secondary,
    background: theme.palette.background.paper,
    textTransform: "capitalize",
  }));

  const Notify_Details = {
    fontWeight: 500,
    fontSize: "16px",
    color: "rgb(13, 110, 124)",
    paddingTop: 20,
    marginLeft: 15,
    marginBottom: 15,
  };

  const history = useHistory();

  const studentDetails = (id) => {
    history.push(`/students/student-detail/${id}`);
    setIsVisibleGlobalSearchDialog(false);
    setSearchValue("");
  };

  const transactionDetails = (id) => {
    history.push({
      pathname: `/transactions/${id}`,
      state: {
        transaction: transactions,
      },
    });
    setIsVisibleGlobalSearchDialog(false);
    setSearchValue("");
  };
const schoolName = localStorage.getItem("school-name")
  return (
    <div className="topbar-main-container">
      <div className="headerUpper">
        <div className="logo-box">
          <img src={whiteLogo} />
        </div>

        <div className="sidebar-trigger">
          <Button onClick={onCl} >
            <span></span>
            <span></span>
            <span></span>
          </Button>
        </div>
      </div>

      <div className="headerInner">
        {/* <div className="topbar-search-container">
          <div className="topbar-searchbox">
            <i className="fa fa-search" style={{ color: "#bbbbbb", marginLeft: 5 }} />
            <input
              className="topbar-search-input"
              placeholder={t("text_search_students_or_transactions_id")}
              value={searchValue}
              onCl
              onChange={globalSearch}
            />
          </div>
        </div> */}
        <Box textAlign="center" display='flex' flexDirection='column' width="auto" margin="auto">
          <Typography style={{marginBottom:10, marginTop:10, fontSize: "1.15vw"}} variant="h2">{schoolName ? schoolName : t("text_school_fee_management_dashboard")}</Typography>
          <Typography variant="h6" style={{ color: BLUE_EIGHT }}>{t("text_welcome_back")}</Typography>
        </Box>

        {IsVisibleGlobalSearchDialog ? (
          <>
            {loading ? (
              <div className="col-md-6 search_grid_container">
                <div
                  style={{
                    height: "200px",
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                  }}
                >
                  <CircularProgress size={20} style={{ color: "black" }} />
                  {t("text_fetching_data")}
                </div>
              </div>
            ) : (
              <div className="col-md-6 search_grid_container">
                <Grid
                  container
                  spacing={0.5}
                  direction="column"
                  className="serach_grid"
                >
                  <>
                    {responseDataText === "student" ? (
                      <>
                        {students.map((e) => (
                          <Grid
                            item
                            xs={12}
                            className="m-1"
                            style={{ cursor: "pointer" }}
                            onClick={() => studentDetails(e.id)}
                          >
                            <Item>
                              {e.firstName} {e.lastName}
                            </Item>
                          </Grid>
                        ))}
                      </>
                    ) : (
                      <>
                        {transactions.map((e) => (
                          <Grid
                            item
                            xs={12}
                            className="m-1"
                            style={{ cursor: "pointer" }}
                            onClick={() => transactionDetails(e.id)}
                          >
                            <Item>
                              {`${e?.student?.firstName} ${e?.student?.lastName
                                } ${Array(70)
                                  .fill(`\xa0`)
                                  .join("")} Amount: ${amountFormat(e.amount)}`}
                            </Item>
                          </Grid>
                        ))}
                      </>
                    )}
                  </>
                </Grid>
              </div>
            )}
          </>
        ) : (
          <></>
        )}
        <div className="notificationUserDialog">
          <div className="inner-wrapper">
            <div className="bell-icon">
              {newNotify.newNotification ? (
                <Badge
                  color="error"
                  variant="dot"
                >
                  <Typography component="button"
                    className="bell-button"
                    onClick={notify}
                  >
                    <img src={bellIcon} style={{ width: "39px" }} alt="bell-icon" />
                  </Typography>
                </Badge>
              ) : (
                <Typography component="button"
                  className="bell-button"
                  onClick={notify}
                >
                    <Lottie animationData={bellIconAnimation} style={{ width:39 }} loop={true} />
                </Typography>
              )}

              {notifyPop && (
                <div className="col-md-4 notify_pop">
                  <h3 style={Notify_Details}>
                    <strong>{t("text_notifications")}</strong>
                  </h3>
                  <Grid container spacing={2} className="notify_grid">
                    {notifyStorage ? (
                      <>
                        {notifyStorage.map((e) => (
                          <Grid
                            item
                            xs={10}
                            className="my-1"
                            style={{
                              borderTop: "1px solid #F1F1F3",
                            }}
                          >
                            <div className="d-flex justify-content-start align-items-center m-0">
                              <div
                                style={{
                                  height: 30,
                                  width: 30,
                                  background: "#ffe3b2",
                                  borderRadius: 10,
                                }}
                              ></div>
                              <div className="" style={{ marginLeft: 10, }}>
                                <strong className="m-0" style={{ fontSize: 12 }}>
                                  {e.message}
                                </strong>
                                <p className="m-0" style={{ fontSize: 12, }}>
                                  {moment(e.date).fromNow()}
                                </p>
                              </div>
                            </div>
                          </Grid>
                        ))}
                      </>
                    ) : (
                      <></>
                    )}
                  </Grid>
                  <div className="close_PopUp" onClick={notify}></div>
                </div>
              )}
            </div>
            <div className="seperator"></div>
            <div>
              <div>
                <Button href="#" className="user-profile-btn">
                  <i className="fas fa-chevron-down cyan-text" />
                  <div style={{ display: 'flex', flexDirection: 'column', marginRight:22 }}>
                    <Typography variant="body1" style={{ color: 'black', textTransform: "capitalize", fontWeight:500 }}>{userData?.firstName} {userData?.lastName}</Typography>
                    <Typography variant="h5" style={{textTransform: "capitalize", color:"#636365", fontWeight:500}}>{userData?.role || "User"}</Typography>
                  </div>

                  <div
                    style={{
                      overflow: "hidden",
                      height: "47px",
                      width: "47px",
                      borderRadius: 50,
                      background: "#006E7D",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      color: "white",
                      marginRight: 10,
                      marginTop: 3,
                    }}
                  >
                    {base64.file
                      ? (
                        <img style={{ height: "inherit", width: "inherit", objectFit: "cover" }} src={base64.file} alt="" />
                      )
                      : userData?.file && userData?.file !== "null" ? (
                        <img
                          style={{ height: "inherit", width: "inherit", objectFit: "cover" }}
                          src={`${userData?.file}`}
                          alt=""
                        />
                      )
                        : <Avatar style={{ backgroundColor: PrimaryBackgroundColor }} />}
                  </div>
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
